import * as Animate from "react-reveal";

const roleGroups = [
  {
    number: "01",
    tag: "Build the product",
    title: "Technical talent",
    links: [
      "Software Engineering",
      "AI / ML",
      "Data",
      "Cloud",
      "Cybersecurity",
      "Product",
      "UI/UX",
      "QA",
    ],
  },
  {
    number: "02",
    tag: "Grow the business",
    title: "Business talent",
    links: [
      "Sales",
      "Customer Success",
      "Marketing",
      "Operations",
      "Finance Operations",
      "People Operations",
      "Business Analysis",
      "Project Management",
    ],
  },
];

const HireRolesSection = () => {
  return (
    <section className="bg-[#f5f7fc] py-16 md:py-20 lg:py-24 px-4" id="roles">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-hire-categories gap-10 lg:gap-16">
        <Animate.Fade bottom>
          <div className="lg:sticky lg:top-28 lg:self-start">
            <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
              <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
              Talent Categories
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black tracking-[-0.03em] mb-6">
              <span className="text-default">Build the product. Grow</span>{" "}
              <span className="text-primary">the business.</span>
            </h2>
            <span className="text-gray text-base md:text-lg font-poppins leading-relaxed block">
              Access the capabilities your company needs without navigating a
              marketplace of profiles.
            </span>
          </div>
        </Animate.Fade>

        <div className="grid gap-4 md:gap-5">
          {roleGroups.map((group) => (
            <Animate.Fade bottom key={group.title}>
              <article className="border border-hire-line bg-white rounded-3xl p-6 md:p-8">
                <div className="flex items-center gap-4 pb-5 mb-6 border-b border-hire-line">
                  <span className="w-12 h-12 rounded-xl bg-secondary text-primary font-poppins font-extrabold flex items-center justify-center flex-shrink-0">
                    {group.number}
                  </span>
                  <div>
                    <p className="text-[#8b5a00] font-poppins text-xs font-extrabold tracking-widest uppercase mb-1">
                      {group.tag}
                    </p>
                    <h3 className="text-primary font-poppins font-bold text-2xl m-0">
                      {group.title}
                    </h3>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
                  {group.links.map((link) => (
                    <a
                      key={link}
                      href="https://app.utiva.co/signup?goal=employer"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="text-default font-poppins font-bold text-sm md:text-base flex items-center justify-between border-b border-[#e7ebf4] py-3"
                    >
                      {link}
                      <span aria-hidden="true" className="text-primary">
                        ↗
                      </span>
                    </a>
                  ))}
                </div>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HireRolesSection;
